module.exports = __webpack_public_path__ + "img/comm_10.2b3b7853.jpg";